import { render, staticRenderFns } from "./ProgressBreakdown.vue?vue&type=template&id=3586069a&scoped=true&"
import script from "./ProgressBreakdown.vue?vue&type=script&lang=js&"
export * from "./ProgressBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./ProgressBreakdown.vue?vue&type=style&index=0&id=3586069a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3586069a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
